import {Injectable, Inject} from '@angular/core';
import {Headers, Response, Http} from "@angular/http";
import {SigninService} from "./signin.service";
import {environment} from "../environments/environment";
import {Observable} from "rxjs";

@Injectable()
export class ApiRequestService {

  private actionUrl: string;

  constructor(
    private _http: Http,
    @Inject('signin') private signin: SigninService,
  ) {
    this.actionUrl = environment.actionUrl;
  }

  private getHeaders(): Headers{
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('Accept', 'application/json');
    headers.append('Authorization', 'Basic '
      + btoa(this.signin.login + ':' + this.signin.pass)
    );
    //headers.append('Access-Control-Allow-Origin', '*');
    return headers;
  }

  public getPecplus(data: any): Observable<any> {
    return this._http.post(this.actionUrl + "pecplus", JSON.stringify({patients: data}), { headers: this.getHeaders() })
      .map((response: Response) => <any>response.json())
      .catch(ApiRequestService.handleError);
  };

  public getTracesUrl() {
    return this.actionUrl + 'pecplus/traces/' + this.signin.login;
  }

  private static handleError (error: Response) {
    let errorText;
    if (error.status == 200) {
      errorText = 'The whole server is down. The connection has been refused.';
    }
    return Observable.throw(errorText || 'Server error');
  }

}



// WEBPACK FOOTER //
// ./src/app/api-request.service.ts